import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation Login($Mobile_Number: String!, $password: String!) {
    login(Mobile_Number: $Mobile_Number, password: $password) {
      id
      First_Name
      Last_Name
      Mobile_Number
      Role
      Payment_Status
      isAdmin
    }
  }
`;

export const ADD_MEMBER_MUTATION = gql`
  mutation AddZoneMember(
    $NAME: String!
    $MOBILE1: String!
    $CITY: String!
    $MOBILE2: String
    $ADDRESS: String
    $NAGAR: String
    $AREA: String
    $PINCODE: String
  ) {
    addZoneMember(
      NAME: $NAME
      MOBILE1: $MOBILE1
      CITY: $CITY
      MOBILE2: $MOBILE2
      ADDRESS: $ADDRESS
      NAGAR: $NAGAR
      AREA: $AREA
      PINCODE: $PINCODE
    ) {
      NAME
      MOBILE1
      MOBILE2
      ADDRESS
      NAGAR
      AREA
      CITY
      PINCODE
      role
    }
  }
`;


export const EDIT_ZONE_MEMBER_MUTATION = gql`
  mutation EditZoneMember(
    $mobile: String!
    $NAME: String!
    $MOBILE1: String!
    $MOBILE2: String
    $ADDRESS: String!
    $NAGAR: String
    $AREA: String
    $CITY: String!
    $PINCODE: String!
    $role: String
  ) {
    editZoneMember(
      mobile: $mobile
      NAME: $NAME
      MOBILE1: $MOBILE1
      MOBILE2: $MOBILE2
      ADDRESS: $ADDRESS
      NAGAR: $NAGAR
      AREA: $AREA
      CITY: $CITY
      PINCODE: $PINCODE
      role: $role
    ) {
      NAME
      MOBILE1
      MOBILE2
      ADDRESS
      NAGAR
      AREA
      CITY
      PINCODE
      role
    }
  }
`;


export const DELETE_MUTATION = gql`
  mutation DeleteZoneMember($mobile: String!) {
    deleteZoneMember(mobile: $mobile)
  }
`;




